
export { default as anyPass } from "./anyPass.js"